import { S3Link } from "./s3Link";

export enum ExecutionStatus {
    Finished = 'Finished',
	Running = 'Running',
	Failed = 'Failed',
	Pending = 'Pending',
    Queued = 'Queued',
    Aborted = 'Aborted'
}

export const statusToSfnStatus = (status: ExecutionStatus): string => {
    switch (status) {
        case ExecutionStatus.Finished:
            return 'SUCCEEDED';
        case ExecutionStatus.Running:
            return 'RUNNING';
        case ExecutionStatus.Failed:
            return 'FAILED';
        case ExecutionStatus.Pending:
            return 'PENDING';
        case ExecutionStatus.Queued:
            return 'PENDING';
        case ExecutionStatus.Aborted:
            return 'ABORTED';
        default:
            throw new Error(`Unknown status: ${status}`);
    }
}

export const sfnStatusToExecutionStatus = (status: string): ExecutionStatus => {
    switch (status) {
        case 'SUCCEEDED':
            return ExecutionStatus.Finished;
        case 'RUNNING':
            return ExecutionStatus.Running;
        case 'FAILED':
            return ExecutionStatus.Failed;
        case 'PENDING':
            return ExecutionStatus.Pending;
        case 'ABORTED':
            return ExecutionStatus.Aborted;
        default:
            throw new Error(`Unknown status: ${status}`);
    }
}

export const isRunningOrQueued = (status: ExecutionStatus): boolean => {
    return status === ExecutionStatus.Running || status === ExecutionStatus.Queued;
}

export interface ExecutionDetails {
    id: string;
    scanId: string;
    projectId: string;
    projectName: string;
    phase: string;
    executionParamsLink: S3Link;
    executionArn: string;
    status: ExecutionStatus;
}

export interface ExecutionARN {
    id: string;
    executionArn: string;
}

export const deserializeExecutionDetails = (data: any): ExecutionDetails => {
    return {
        id: data.id,
        scanId: data.scan_id,
        projectId: data.project_id,
        projectName: data.project_name,
        phase: data.phase,
        executionParamsLink: {
            bucket: data.execution_params_link.bucket,
            key: data.execution_params_link.key
        } as S3Link,
        executionArn: data.execution_arn,
        status: data.status as ExecutionStatus
    };
};